import ConnectIcon from "../../../assets/svg/connect.svg";
import React from "react";

interface SpinnerProps {
  message?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ message }) => {
  return (
    <div className="flex flex-row items-center self-center m-4">
      <img src={ConnectIcon} className="w-8 h-8 animate-spin mr-1" alt="loading..." />
      <span>{message}</span>
    </div>
  );
};
